import React, { useEffect, useState } from "react";
import { pDialogTab } from "../../utils/parameters";
import { IconButton } from "@material-ui/core";
import { Favorite, FavoriteBorder } from "@material-ui/icons";
import ArrowBackIosIcon from "@mui/icons-material/ArrowBackIos";
import { useDataProvider } from "../../api/DataProvider";
import CloseIcon from "@material-ui/icons/Close";
import { DialogTitle } from "@material-ui/core";
import "../../styles/devices/mob_SignDialog.css";
import SignLanguageIcon from "@mui/icons-material/SignLanguage";
import { useCommProvider } from "../../api/CommProvider";

export default function DialogHeader(props) {
  const { dialogPosition, tabValue, setTabValue, handleClose, arr_history, returnLastEntryHistory } = props;
  const { comm_addFavorites, comm_removeFavorites } = useCommProvider();
  const { token_id, currentUser, json_data_USER, set_json_data_USER, json_data_lemma, json_data_glosses } = useDataProvider();

  // Variables used in the component
  const [isFavorite, setIsFavorite] = useState(undefined);  // undefined not loaded info about user (maybe invited) otherwise true or false depending if the lemma is in json_data_USER['session']['arr_favorites']
  const [title, setTitle] = useState("");
  const [accesible, setAccesible] = useState("");

  // Update dialog depens on dialogPosition changes
  useEffect(() => {
    // console.log("🚀 ~ file: DialogHeader.js:39 ~ DialogHeader ~ dialogPosition:", dialogPosition)
    // Update title
    let text_title = json_data_lemma[dialogPosition["lemma"]]["label"]
    // if (json_data_glosses[dialogPosition["gloss"]]!==undefined){
    //   text_title = text_title + ' ['+dialogPosition["gloss"]+']'
    // }
    setTitle(text_title);

    // Update accesible icons information
    setAccesible(json_data_lemma[dialogPosition["lemma"]]["accesible"]);

    // Update favorite icon depending if the lemma is in the favorites list or not, so it depends on the dialogPosition and (in minor freq) the json_data_USER.
    setIsFavorite(json_data_USER['session']['arr_favorites'].includes(dialogPosition["lemma"]));
    
  }, [dialogPosition, json_data_USER]);
  


  async function onEliminateFav() {
    try{
      set_json_data_USER(await comm_removeFavorites(token_id, currentUser, dialogPosition["lemma"]))
    }catch(e){
      console.error(e)
    }
  }

  async function onAddFav() {
    try{
      set_json_data_USER(await comm_addFavorites(token_id, currentUser, dialogPosition["lemma"]))
    }catch(e){
      console.error(e)
    }
  }
  
  return (
    <div className="sig_SignDialog_TitleContainer">
      <DialogTitle onClose={handleClose}>
        {tabValue > pDialogTab.none ? (
          <>
            <IconButton
              aria-label="fav"
              className="sig_SignModal_FavButton"
              onClick={isFavorite ? onEliminateFav : onAddFav}
              style={{
                visibility: isFavorite !== undefined ? "visible" : "hidden",
              }}
            >
              {isFavorite ? <Favorite /> : <FavoriteBorder />}
            </IconButton>
            <div className="sig_SignModal_DialogTitle">
              {arr_history[0] !== undefined || tabValue === -1 ? (
                <IconButton
                  aria-label="fav"
                  className="sig_SignModal_FavButton"
                  onClick={returnLastEntryHistory}
                  style={{
                    visibility: isFavorite !== undefined ? "visible" : "hidden",
                  }}
                >
                  {<ArrowBackIosIcon />}
                </IconButton>
              ) : (
                <></>
              )}

              <span className={`sig_SignDialog_Lemma${ accesible }`}>
                {title} <SignLanguageIcon fontSize="small" />
              </span>
            </div>
          </>
        ) : (
          <>
            <div className="sig_SignModal_DialogTitle">
              <IconButton
                aria-label="fav"
                className="sig_SignModal_FavButton"
                onClick={() => setTabValue(0)}
                style={{
                  visibility: isFavorite !== undefined ? "visible" : "hidden",
                }}
              >
                {<ArrowBackIosIcon />}
              </IconButton>
            </div>
          </>
        )}
        <IconButton aria-label="close" className="sig_SignModal_CloseButton" onClick={handleClose}>
          <CloseIcon />
        </IconButton>
      </DialogTitle>
    </div>
  );
}
